// React
import React, { Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import { compose } from 'redux'

// Libraries

// Components
import BMiniCart from 'shop-components/components/MiniCart/styles'
import Button from 'ui/components/Button'
import Line from './Line'
import { PoweredBy } from 'shop-components/components/PoweredBy'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTriangleExclamation as farTriangleExclamation,
  faSpinnerThird as farSpinnerThird
} from '@fortawesome/pro-regular-svg-icons'

// Shared
import { withTranslation } from 'shared/utils/withTranslation'
import clientActions from 'store/v2/redux/actions/client'

export const Lines = ({ hasDates, cannotCheckout, lines, toggleCart, showPoweredBy, loading, t }) => {
  useEffect(() => {
    return () => {
      clientActions.setCartScroll(0)
    }
  }, [])

  return (
    <Fragment>
      {hasDates && cannotCheckout && (
        <BMiniCart.Notice>
          <FontAwesomeIcon icon={farTriangleExclamation} size="lg" />
          {t('user.store.not_all_products_available')}
        </BMiniCart.Notice>
      )}
      {lines.size() > 0 && !loading && (
        <ul>
          <li>
            {lines.map((line) => {
              return <Line key={line.id} line={line} hasDates={hasDates} />
            })}
          </li>
        </ul>
      )}
      {!lines.size() && (
        <BMiniCart.Cleanstate>
          {loading && (
            <FontAwesomeIcon icon={farSpinnerThird} spin />
          )}
          {!loading && (
            <Fragment>
              {t('user.store.cart_empty')}
              <Button onClick={toggleCart.bind(null, false)} size="sm">
                {t('user.store.continue_shopping')}
              </Button>
            </Fragment>
          )}
        </BMiniCart.Cleanstate>
      )}
      {lines.size() === 0 && showPoweredBy && (
        <BMiniCart.PoweredBy cleanstate>
          <PoweredBy logoWidth="24px" />
        </BMiniCart.PoweredBy>
      )}
    </Fragment>
  )
}

Lines.displayName = 'Lines'
Lines.propTypes = {
  hasDates: PropTypes.bool,
  cannotCheckout: PropTypes.bool,
  lines: PropTypes.object,
  toggleCart: PropTypes.func,
  showPoweredBy: PropTypes.bool,
  loading: PropTypes.bool,
  t: PropTypes.func
}

const mapStateToProps = (state, props) => {
  const { cartOpen } = state.client

  return {
    cartOpen,
    lines: state.orm.lines.getAll({ id: props.cart?.lines }).filter(({ product_type: type }) => type !== 'service'),
    showPoweredBy: state.settings.get('store.show_powered_by')
  }
}

export default compose(
  withTranslation('user'),
  reduxConnect(mapStateToProps)
)(Lines)
